export enum ProfileEndpoint {
  Base = '/profile',
  Password = '/password',
  Change = '/change',
  MapsPluginAccept = '/maps-plugin/accept',
}
